goog.provide("shadow.js.shim.module$src$svg$files_folders$bin_svg");
goog.provide("module$shadow_js_shim_module$src$svg$files_folders$bin_svg");
shadow.js.shim.module$src$svg$files_folders$bin_svg = shadow.js.nativeProvides["src/svg/files_folders/bin.svg"] = shadow$bridge("src/svg/files_folders/bin.svg");
module$shadow_js_shim_module$src$svg$files_folders$bin_svg.default = shadow.js.shim.module$src$svg$files_folders$bin_svg;
